import { Outlet } from "react-router";
import { Nav } from "@/components/layout/nav";
import { MobileNav } from "@/components/layout/mobile-nav";
import { MobileHeader } from "@/components/layout/mobile-header";
import { Footer } from "@/components/layout/footer";

export function AppLayout() {
  return (
    <div className="flex min-h-dvh flex-col">
      <Nav />
      <MobileHeader />

      <main className="flex-1 px-4 py-6 md:px-6 md:py-8">
        <div className="mx-auto w-full max-w-7xl">
          <Outlet />
        </div>
      </main>

      <Footer />
      <MobileNav />

      {/* Spacer so content isn't hidden behind the fixed mobile nav */}
      <div className="h-16 md:hidden" aria-hidden="true" />
    </div>
  );
}
